import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';
import PageHero from '../../../components/feature/PageHero';
import { useNavigate } from 'react-router-dom';

const WHATSAPP_URL = 'https://wa.me/5511913278081?text=Ol%C3%A1%2C%20preciso%20de%20assessoria%20em%20Direito%20Civil.';

const servicos = [
  {
    titulo: 'Contratos e Negócios',
    descricao: 'Elaboração, revisão e negociação de contratos empresariais e pessoais: prestação de serviços, compra e venda, locação, parceria comercial, confidencialidade e demais instrumentos contratuais.',
  },
  {
    titulo: 'Responsabilidade Civil',
    descricao: 'Atuação em demandas de responsabilidade civil contratual e extracontratual, representando clientes tanto na posição de autor quanto de réu, com estratégia processual focada no melhor resultado.',
  },
  {
    titulo: 'Danos Morais e Materiais',
    descricao: 'Propositura e defesa em ações de indenização por danos morais e materiais, com análise criteriosa da extensão dos danos, nexo causal e adequação do pedido à jurisprudência vigente.',
  },
  {
    titulo: 'Resolução de Conflitos',
    descricao: 'Negociação extrajudicial, mediação e conciliação para resolução de conflitos civis e empresariais, priorizando soluções ágeis, menos custosas e preservadoras das relações entre as partes.',
  },
  {
    titulo: 'Assessoria Preventiva',
    descricao: 'Análise prévia de contratos, transações e operações para identificação de riscos civis e sugestão de medidas de proteção, evitando litígios e passivos futuros antes que se materializem.',
  },
  {
    titulo: 'Locação e Imóveis',
    descricao: 'Assessoria em contratos de locação residencial e comercial, ação de despejo, revisional de aluguel, cobrança de aluguéis em atraso e demais questões relativas a imóveis urbanos.',
  },
  {
    titulo: 'Direito de Família',
    descricao: 'Assessoria em divórcio, partilha de bens, guarda de filhos, alimentos, dissolução de união estável e reconhecimento de paternidade, com atuação focada na composição amigável ou na defesa judicial dos interesses do cliente.',
  },
  {
    titulo: 'Direito Previdenciário',
    descricao: 'Acompanhamento em processos de concessão, revisão e manutenção de benefícios junto ao INSS — aposentadorias, auxílios, pensões e BPC — com análise técnica de tempo de contribuição e cálculo de benefícios.',
  },
];

export default function CivilPage() {
  const navigate = useNavigate();

  return (
    <main className="font-sans">
      <Header />
      <PageHero
        tag="Área de Atuação"
        titulo="Direito"
        tituloItalico="Civil"
        subtitulo="Atuação em contratos, responsabilidade civil, família e resolução de conflitos. Assessoria jurídica preventiva e contenciosa para pessoas e empresas."
      />

      {/* Intro */}
      <section className="py-[60px] bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#B39B62]"></span>
            <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
              Nossa atuação
            </span>
          </div>
          <h2 className="font-serif text-3xl lg:text-4xl text-[#0A1829] font-light leading-snug mb-6">
            Soluções jurídicas <span className="italic text-[#B39B62]">na esfera cível</span>
          </h2>
          <p className="font-sans text-[#0A1829]/70 text-base leading-relaxed mb-4">
            O Direito Civil regula as relações mais presentes no cotidiano de pessoas e empresas — contratos, propriedade, responsabilidade, família e previdência. Uma assessoria civil especializada garante que você negocie e aja com segurança jurídica, prevenindo conflitos e protegendo seus interesses em todas as suas relações.
          </p>
          <p className="font-sans text-[#0A1829]/70 text-base leading-relaxed mb-4">
            No escritório <strong className="font-semibold text-[#0A1829]">Moreira Tófoli Advogados</strong>, a atuação civil combina rigor técnico com abordagem estratégica. Priorizamos soluções negociadas quando possível, e atuamos com firmeza no contencioso quando necessário, sempre orientados pelo melhor interesse do cliente.
          </p>
          <p className="font-sans text-[#0A1829]/70 text-base leading-relaxed mb-3">
            Nossa assessoria preventiva permite que contratos, negócios e relações sejam estruturados desde o início de forma a minimizar riscos e garantir a proteção dos seus direitos a longo prazo.
          </p>
          <div className="grid grid-cols-3 gap-6 pt-6 border-t border-[#E9D59C]/40">
            <div>
              <div className="font-serif text-xl text-[#B39B62] font-light mb-1">Contratos</div>
              <div className="font-sans text-xs text-[#0A1829]/50 leading-relaxed">Elaboração e revisão de instrumentos contratuais</div>
            </div>
            <div>
              <div className="font-serif text-xl text-[#B39B62] font-light mb-1">Família</div>
              <div className="font-sans text-xs text-[#0A1829]/50 leading-relaxed">Divórcio, guarda, alimentos e partilha de bens</div>
            </div>
            <div>
              <div className="font-serif text-xl text-[#B39B62] font-light mb-1">Prevenção</div>
              <div className="font-sans text-xs text-[#0A1829]/50 leading-relaxed">Assessoria preventiva para evitar litígios futuros</div>
            </div>
          </div>
        </div>
      </section>

      {/* Serviços */}
      <section className="py-[60px] bg-[#F8F5EE]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-6">
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="h-px w-12 bg-[#B39B62]"></span>
              <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
                Serviços
              </span>
              <span className="h-px w-12 bg-[#B39B62]"></span>
            </div>
            <h2 className="font-serif text-3xl lg:text-4xl text-[#0A1829] font-light">
              O que <span className="italic text-[#B39B62]">abrangemos</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {servicos.map((s) => (
              <div key={s.titulo} className="bg-white border border-[#E9D59C]/40 rounded-lg p-6 hover:-translate-y-1 transition-transform duration-300">
                <h3 className="font-serif text-base text-[#0A1829] font-medium mb-2">{s.titulo}</h3>
                <p className="font-sans text-[#0A1829]/55 text-xs leading-relaxed">{s.descricao}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-[60px] bg-[#0A1829] text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="font-serif text-3xl lg:text-4xl text-white font-light mb-4">
            Precisa de <span className="italic text-[#E9D59C]">assessoria civil?</span>
          </h2>
          <p className="font-sans text-white/55 text-base leading-relaxed mb-3">
            Proteja seus contratos, seus direitos e seu patrimônio com a assessoria jurídica adequada.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#B39B62] hover:bg-[#E9D59C] text-[#0A1829] font-sans font-semibold text-base px-10 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Falar com advogado
            </a>
            <a
              href="/atuacao"
              onClick={(e) => { e.preventDefault(); navigate('/atuacao'); }}
              className="inline-flex items-center justify-center gap-2 border border-white/30 text-white hover:border-[#B39B62] hover:text-[#B39B62] font-sans font-medium text-base px-8 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Ver todas as áreas
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
